import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Typography from 'fuse-ui/components/Typography';
import Warning from '../../common/components/warning';

import UNVERIFIED_SENDER_MESSAGES from './constants/unverified-sender-messages';
import { action, opacity } from '../../common/theme/colors';

const styles = theme => ( {
    card: {
        '&:hover': {
            backgroundColor: opacity.black08
        },
        cursor: 'pointer',
        padding: '8px 24px',
    },
    content: {
        height: '100%',
        overflow: 'auto',
    },
    contentContainer: {
        flexGrow: 1, /* takes the remaining height of the "container" after the warning message*/
        overflow: 'auto'
    },
    focusedCard: {
        '&:hover': {
            backgroundColor: action.focus
        },
        backgroundColor: action.focus
    },
    unverifiedSendersContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100% - 44px)', //makes up for the extra header padding on the widget
        margin: '0 -24px 0 -24px', //fix for the warning container to be full width
        overflowY: 'auto',
    },
} );

export const UnverifiedSenders = ( { classes, handleOpenDetailsPane, selectedSenderId, senders } ) => {
    return (
        <div className={classes.unverifiedSendersContainer}>
            <div data-automation-id="unverified-senders-warning">
                <Warning>{UNVERIFIED_SENDER_MESSAGES.warning}</Warning>
            </div>
            <div className={classes.contentContainer}>
                <Grid container data-automation-id="unverified-senders-list" className={classes.content}>
                    {
                        senders.map( ( sender, index ) => (
                            <Grid
                                className={cx( classes.card, {
                                    [classes.focusedCard]: selectedSenderId === sender.senderId
                                } )}
                                date-automation-id={`unverified-sender-card-${index}`}
                                item
                                key={sender.senderId}
                                onClick={() => handleOpenDetailsPane( sender.senderId, sender.name )}
                                sm={6}
                                xs={12}
                            >
                                <Typography variant="subtitle1">{sender.name}</Typography>
                                <Typography variant="caption" color="textSecondary">
                                        Sending on {sender.domainsCount} domain{sender.domainsCount > 1 && 's'}
                                </Typography>
                            </Grid>
                        ) )
                    }
                </Grid>
            </div>
        </div>

    );
};

UnverifiedSenders.propTypes = {
    classes: PropTypes.object.isRequired,
    handleOpenDetailsPane: PropTypes.func.isRequired,
    selectedSenderId: PropTypes.string.isRequired,
    senders: PropTypes.array,
};

export default withStyles( styles )( UnverifiedSenders );
